"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// ES Modules
var easydropdown_1 = __importDefault(require("easydropdown"));
exports.default = (function () {
    var selectElement = Array.from(document.querySelectorAll('[data-select]'));
    var formSelect = Array.from(document.querySelectorAll('.Form select'));
    __spreadArrays(selectElement, formSelect).map(function (el) { return easydropdown_1.default(el); });
});
